import { useEffect, useState, useCallback, useRef } from "react";
import { ProgramacionMantenimientoService } from "services/ProgramacionMantenimientoService";

export const useProgramacionesMantenimiento = (filters = {}) => {
  const [programaciones, setProgramaciones] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
  });

  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const fetchProgramaciones = useCallback(async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await ProgramacionMantenimientoService.listar({ page, ...filtersRef.current });
      setProgramaciones(response.data.results || response.data);
      setPagination({
        count: response.data.count || 0,
        next: response.data.next || null,
        previous: response.data.previous || null,
      });
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProgramaciones();
  }, []);

  const createProgramacion = async (data) => {
    const response = await ProgramacionMantenimientoService.crear(data);
    await fetchProgramaciones();
    return response.data;
  };

  const updateProgramacion = async (uuid, data) => {
    const response = await ProgramacionMantenimientoService.actualizar(uuid, data);
    await fetchProgramaciones();
    return response.data;
  };

  const deleteProgramacion = async (uuid) => {
    await ProgramacionMantenimientoService.eliminar(uuid);
    await fetchProgramaciones();
  };

  return {
    programaciones,
    isLoading,
    error,
    pagination,
    fetchProgramaciones,
    createProgramacion,
    updateProgramacion,
    deleteProgramacion,
  };
};
